import { Component } from '@angular/core';

@Component({
  selector: 'app-help-links',
  templateUrl: './help-links.component.html',
  styleUrls: ['./help-links.component.scss'],
  standalone: false,
})
export class HelpLinksComponent {
  links: { text: string; url: string }[] = [
    {
      text: 'SESIS InfoHub',
      url: 'https://infohub.nyced.org/nycps-topics/specialized-areas/special-education/sesis',
    },
    {
      text: 'Procedural Safeguards Notice',
      url: 'https://www.schools.nyc.gov/learning/special-education/help/your-rights',
    },
    {
      text: 'Special Education Standard Operating Procedures Manual (SOPM)',
      url: 'https://rebrand.ly/NYCSpecialEducationSOPM',
    },
    {
      text: 'Encounter Attendance Help Guide',
      url: 'https://infohub.nyced.org/partners-and-providers/special-ed-partners/sesis-related-services-providers',
    },
    {
      text: 'Translated Parent Notifications',
      url: 'http://rebrand.ly/translated-parent-notifications',
    },
    {
      text: 'Chancellor\'s Regulations',
      url: 'https://www.schools.nyc.gov/school-life/policies-for-all/chancellors-regulations',
    },
    {
      text: 'NYSED Laws and Regulations Related to Special Education',
      url: 'https://www.nysed.gov/special-education/laws-and-regulations-related-special-education-and-students-disabilities',
    },
    {
      text: 'Medical Accommodation Packet Forms',
      url: 'http://rebrand.ly/doe-medical-accommodations-packet-forms',
    },
    {
      text: 'NYCDOE Testing Accommodations Guide',
      url: 'http://rebrand.ly/NYCDOE-testing-accommodations',
    },
    {
      text: 'NYCDOE Alternate Assessment (ncluiding NYSAA) FAQs',
      url: 'http://rebrand.ly/NYCDOE-alternate-assessment',
    },
    {
      text: 'CORE and Variance Requests',
      url: 'http://rebrand.ly/core-variance-requests',
    },
    {
      text: 'NYSED Approved Non-Public Schools',
      url: 'https://www.nysed.gov/special-education/approved-special-education-programs-preschool-and-school-age',
    },
  ];
}
